import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { Vector2 } from "kea-react/dist/signatureCanvas";

/**Convierte la representación de cadena de una firma a un arreglo de arreglos de vectores */
function toVector(cadena: string): Vector2[][] {
    const ret = cadena
        .split('|')
        .map(x => x
            .split(';')
            .map(x => x.split(','))
            .map<Vector2>(x => ({
                x: Number.parseFloat(x[0]),
                y: Number.parseFloat(x[1])
            }))
        );

    return ret;
}

export interface Props {
    /**Representación de cadena de la firma, separados los segmentos, puntos y componentes por
     * pipe (|), punto y coma (;) y coma(,)
     */
    value: string;
    label?: string;
}

/**Muestra una firma que esta representada en forma de cadena */
export class FirmaCadenaComponent extends React.PureComponent<Props> {
    render() {
        const vectores = toVector(this.props.value);
        return (
            <kea.SignaturePad 
                readonly
                value={vectores}
                label={this.props.label}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/firmacadena.tsx